import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { pagesState, mySession, getTenantAsync, GetOrderAsync, updateActivePage, filterOrder, checkSessionAsync, paginationChanged } from './controller';
import useDynamicRefs from 'use-dynamic-refs';
import moment from 'moment';
import { Pagination } from "react-pagination-bar"
import 'react-pagination-bar/dist/index.css'
import CurrencyFormat from 'react-currency-format';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export function Requests() {
    const dispatch = useDispatch();
    const pages_state = useSelector(pagesState);
    const my_Session = useSelector(mySession);
    const [getRef, setRef] = useDynamicRefs();

    const [startDate, setStartDate] = useState(pages_state && pages_state.filter && pages_state.filter.FromDate ? new Date(pages_state.filter.FromDate) : '');
    const [endDate, setEndDate] = useState(pages_state && pages_state.filter && pages_state.filter.ToDate ? new Date(pages_state.filter.ToDate) : '');

    const toggleDateChange = (date) => {
        setStartDate(date);
        var data = {
            name: 'startDate',
            value: moment(date).format('YYYY-MM-DD')
        }
        dispatch(filterOrder(data));
    }

    const toggleDateEndChange = (date) => {
        setEndDate(date);
        var data = {
            name: 'endDate',
            value: moment(date).format('YYYY-MM-DD')
        }
        dispatch(filterOrder(data));
    }

    var [showFilter, setshowFilter] = useState(false);
    var toggleFilter = () => setshowFilter(!showFilter);

    const PaginationsComponent = (activePage, count) => {
        return <Pagination currentPage={pages_state ? pages_state.activePage : 1} itemsPerPage={10} onPageChange={(el) => goToPage(el)} totalItems={pages_state && pages_state.orderList ? pages_state.orderList.TotalCount : 0} />;
    }

    const goToPage = (pageNumber) => {
        dispatch(paginationChanged(pageNumber));
    }

    const PageInit = async () => {
        await dispatch(checkSessionAsync());
        await dispatch(getTenantAsync());
        await dispatch(GetOrderAsync(pages_state ? pages_state.filter : ''));
    }

    useEffect(() => {
        PageInit()
    }, []);

    const filterValue = async (e) => {
        var data = {
            name: e.target.name,
            value: e.target.value
        }
        await dispatch(filterOrder(data));
    }

    const filterOrderList =async () => {
        await dispatch(GetOrderAsync(pages_state ? pages_state.filter : ''));
    }
    // console.log("pages_state.status", pages_state.status)
    return (
        <section id="requests">
            {(pages_state.status !== 'idle' || pages_state.status === 'rejected') && <div className="position-fixed loadingScreen d-flex justify-content-center align-items-center"><img src="./images/loading.gif" className="icons-loading" alt="" /></div>}
            <div className="container-fluid mt-3 minHeight">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="text-center">
                                <h2 className="pageTitle mt-2">View Request</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-5">
                        <div className="col-md-4 mb-3">
                            <div className="card">
                                <div className="card-header text-light fw-bold text-center text-18" onClick={toggleFilter}>Filter</div>
                                <div className={showFilter ? 'card-body d-block d-md-block' : 'card-body d-none d-md-block'}>
                                    <div>
                                        <div className="mb-3">
                                            <label htmlFor="tenantFilter">Platform:</label>
                                            <select className="form-control fw-bold" name="tenantFilter" id="tenantFilter" defaultValue={pages_state && pages_state.filter ? pages_state.filter.TenantId : ''} onChange={async (e) => await filterValue(e)}>
                                                <option value="">All</option>
                                                {pages_state && pages_state.tenantList && pages_state.tenantList.map((data, index) => {
                                                    return (
                                                        <option key={index} value={data.TenantId}>{data.TenantCode === 'NAS' ? 'Archives Online' : 'National Library Online'}</option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="requestType">Request Type:</label>
                                            <select className="form-control" name="requestType" id="requestType" defaultValue={pages_state && pages_state.filter ? pages_state.filter.PublishStatus : ''} onChange={async (e) => await filterValue(e)}>
                                                <option value="">All</option>
                                                <option value="1">Processing Request(s)</option>
                                                <option value="3">Action Required Request(s)</option>
                                                <option value="2">Completed Request(s)</option>
                                            </select>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="tenantFilter">Request Date From:</label>
                                            {/* <input type="date" name="startDate" className="form-control" defaultValue={pages_state && pages_state.filter ? pages_state.filter.FromDate : ''} onChange={async (e) => await filterValue(e)} /> */}
                                            <DatePicker
                                                selected={startDate}
                                                onChange={(date) => toggleDateChange(date)}
                                                closeOnScroll={true}
                                                peekNextMonth
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                className={'form-control'}
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="dd/mm/yyyy"
                                                maxDate={new Date()}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="tenantFilter">Request Date To:</label>
                                            {/* <input type="date" name="endDate" className="form-control" defaultValue={pages_state && pages_state.filter ? pages_state.filter.ToDate : ''} onChange={async (e) => await filterValue(e)} /> */}

                                            <DatePicker
                                                selected={endDate}
                                                onChange={(date) => toggleDateEndChange(date)}
                                                closeOnScroll={true}
                                                peekNextMonth
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                className={'form-control'}
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="dd/mm/yyyy"
                                                maxDate={new Date()}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <button className="btn btn-primary w-100" onClick={filterOrderList}>Filter</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="card overflow-hidden">
                                <div className="card-header text-light fw-bold text-center text-18">Request List</div>
                                <div className={'card-body'}>
                                    <div className="row m-0">
                                        <div className="col-md-12 p-0 d-flex justify-content-end align-items-center">
                                            <PaginationsComponent />
                                        </div>
                                    </div>

                                    <div className="row m-0">
                                        <div className="col-md-12 p-0">
                                            {pages_state && pages_state.orderList && pages_state.orderList.Orders && pages_state.orderList.Orders.map((data, index) => {
                                                return (
                                                    <div className="card overflow-hidden mb-3 orderlist cursor_pointer" key={index}>
                                                        <Link to={`/my-requests/${data.OrderId}`}>
                                                            <div className="card-body" style={data.LblOrderCompleteOrCancel ? { backgroundColor: '#ddd' } : {}}>
                                                                <div className="card-content d-flex justify-content-between w-100 flex-wrap">
                                                                    <div>
                                                                        <h3 className="theme-color mb-3">{data.OrderCode}
                                                                            {data.Items.filter((item) => item.PublicActionRequired).slice(0, 1).map((item, item_index) => {
                                                                                return (
                                                                                    <span key={item_index} className="text-danger material-icons-outlined align-top ps-2">error</span>
                                                                                )
                                                                            })}

                                                                        </h3>
                                                                        <p className="mb-0"><span className="text-dark">Request Date:</span> <span className="theme-color">{moment(data.OrderCreatedDate).format('DD MMM yyyy')}</span></p>
                                                                    </div>
                                                                    <div className="d-flex align-items-end justify-content-end mt-3">
                                                                        <div>
                                                                            <p className="mb-0"><span className="text-dark">No. of Item(s):</span> <span className="theme-color">{data.Items.length}</span></p>
                                                                            {data.TotalPayableAmount > 0 && <p className="mb-0">
                                                                                <span className="text-dark">Outstanding Fees:</span>
                                                                                <span className="theme-color"><CurrencyFormat value={parseFloat(data.LblTotalPayableAmount).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
                                                                            </p>}
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}





